<template>
  <footer class="app-footer">
    <a href="https://dowhile.com.br/">Dowhile</a> &copy; 2019.
    <span class="float-right">Desenvolvido por <a href="https://dowhile.com.br/" target="_blank">Dowhile</a></span>
  </footer>
</template>
<script>
  export default {
    name: 'footer'
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?3cf0b57a